module.exports = __webpack_public_path__ + "img/13.708cb1a0.png";